import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';

import { BillingError } from '@/components/Billing/billing-types';
import ErrorHandlingService from '@/utils/error-handling-service';

export interface Error {
	response: { data: { error: BillingError } };
}

export const billingErrorHandler = ({ err }: { err: Error }) => {
	const BillingService = require('@/components/Billing/billing-service').default;
	if (BillingService.isBillingError(err)) {
		const store = require('@/store').default;
		const serverError = ErrorHandlingService.extractError(err);
		const errorCode = ErrorHandlingService.extractErrorCode(err);
		const errorMetadata = ErrorHandlingService.extractErrorMetadata(err);
		const canEditBilling = store.getters['account/hasAccountPermission'](AccountPermissions.ChangeBilling);

		const requestAccess = () => store.dispatch('billing/requestFeatureAccess', { hashId: errorMetadata?.workflow_hash }, { root: true });
		const userRole = store.getters['user']?.profile?.account?.role; // user might be undefined, in customer portal for example
		BillingService.handleBillingError({ error: serverError, errorCode, userRole, canEditBilling, requestAccess });
	}
	throw err;
};
